// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"d25537bc","636":"fa18625f"}[chunkId] + ".chunk.css";
};